;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.bpu.edit')
    .controller('BpuEditController', BpuEditController)

  BpuEditController.$inject = [
    // Angular
    '$state',
    // Libs
    // Managers
    // Services
    'DatePickerService', 'EntityService', 'SnackService',
    // Const
    // Resolved
    'bpu', 'customFields'
  ]

  function BpuEditController (
    // Angular
    $state,
    // Libs
    // Managers
    // Services
    DatePickerService, EntityService, SnackService,
    // Const
    // Resolved
    bpu, customFields
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        bpu: bpu,
        customFields: customFields,
        // Public Method
        removeClient: removeClient,
        save: save,
        selectDate: selectDate,
        selectEntity: selectEntity
      })
    }

    function selectDate (field) {
      var opt = {}
      switch (field) {
        case 'start':
          if (self.bpu.end) {
            opt.maxDate = self.bpu.end
          }
          break
        case 'end':
          if (self.bpu.start) {
            opt.minDate = self.bpu.start
          }
          break
      }
      DatePickerService.getRange(self.bpu[field], opt).then(function (date) {
        self.bpu[field] = new Date(date)
      })
    }

    function selectEntity () {
      var config = {
        title: 'Sélectionner Client',
        headerAction: 'Créer un nouveau client',
        accessibleTypes: ['Organization', 'Agency', 'professional', 'individual'],
        from: 'sufa'
      }
      EntityService.prompt(config).then(function (entity) {
        if (!Array.isArray(_.get(self.bpu, 'client'))) {
          self.bpu.client = []
        }
        if (self.bpu.client.map(c => c._id).includes(entity._id)) {
          return
        }
        self.bpu.client.push(entity)
      })
    }

    function removeClient (index) {
      self.bpu.client.splice(index, 1)
    }

    function save () {
      self.bpu.save()
        .then(function () {
          SnackService.snack({
            text: 'BPU sauvegardé',
            delay: 3000
          })
          $state.go('bpu.show', { id: self.bpu._id })
        })
    }
  }
})(window.angular, window._)
